import { Box } from "@mui/material";

import { FilterTable } from "../../../../../Components/FilterTable/FilterTable";
import { FilterTableSkeleton } from "../../../../../Components/FilterTable/FilterTableSkeleton";
import { filters, headerColumns } from "./WizAssetColumns";
import WizAssetRow, { type WizAssetRowData } from "./WizAssetRow";

interface WizAssetTableProps {
  wizConfigs: ReadonlyArray<WizAssetRowData>;
}

const WizAssetTable = ({ wizConfigs }: WizAssetTableProps) => {
  const rowWrapper = ({ row }: { row: WizAssetRowData }) => <WizAssetRow data={row} />;

  return (
    <Box sx={{ mb: 4 }}>
      {wizConfigs === undefined ? (
        <FilterTableSkeleton />
      ) : (
        <FilterTable<WizAssetRowData>
          tableItems={wizConfigs}
          rowComponent={rowWrapper}
          headerColumns={headerColumns}
          filterColumns={filters}
          persistenceKey="WizAssetTable"
          data-cy="wiz-asset-table"
        />
      )}
    </Box>
  );
};

export default WizAssetTable;
